import { JobDetailsHook } from "../hooks/JobDetails.js/jobDetails";
import TextDesc from "../components/JobDetails/textDesc";
import ApplySticky from "../components/JobDetails/applySticky";

const JobDetails = () => {
    let jobDetails = false;
    jobDetails = JobDetailsHook();
    return (
    <div>
        <style>
        @import url('https://fonts.googleapis.com/css2?family=Manrope:wght@200..800&display=swap');
        </style>
        {jobDetails?
        <div class = "backgroundJobDetails mb-10 z-0">
            <div class = "py-5 md:py-10 px-2 grid grid-cols-12">
                <div class = "md:mx-10">
                    <a href ="/job-board">
                        <svg fill="#000000" class = "w-full bg-white rounded-full" version="1.1" id="Capa_1"viewBox="0 0 219.151 219.151">
                            <g>
                                <path d="M94.861,156.507c2.929,2.928,7.678,2.927,10.606,0c2.93-2.93,2.93-7.678-0.001-10.608l-28.82-28.819l83.457-0.008
                                c4.142-0.001,7.499-3.358,7.499-7.502c-0.001-4.142-3.358-7.498-7.5-7.498l-83.46,0.008l28.827-28.825
                                c2.929-2.929,2.929-7.679,0-10.607c-1.465-1.464-3.384-2.197-5.304-2.197c-1.919,0-3.838,0.733-5.303,2.196l-41.629,41.628
                                c-1.407,1.406-2.197,3.313-2.197,5.303c0.001,1.99,0.791,3.896,2.198,5.305L94.861,156.507z"/>
                            </g>
                        </svg>
                    </a>
                </div>
            </div>
            <div class = "h-6 md:h-16">
                <div class = "md:mx-24 px-5 grid grid-cols-5 relative">
                    <div>
                        <img class = "h-12 md:h-32 w-auto px-5 md:px-2 absolute left-0" alt = "Logo Error" src = {jobDetails["Company Logo"][0].url}/>
                    </div>
                </div>   
            </div>
            <div class = "px-10 md:px-10 lg:px-24 pt-10 pb-12 md:pb-0 md:pt-32 bg-white min-h-screen rounded-t-3xl md:gap-x-5 lg:gap-x-20 grid grid-cols-12">
                <div class = "md:hidden col-span-12 md:col-span-4 mt-10">
                    {ApplySticky(jobDetails)}
                </div>
                <div class = "col-span-12 md:col-span-8">
                    <p class = "md:hidden text-left section-heading text-section-heading-mobile md: text-section-heading text-primary-purple pt-10">
                        {jobDetails["Job Role"]}
                    </p>
                    <p class = "text-left paragraph-two-bold text-paragraph-two-mobile md:text-paragraph-two text-stone-500">
                        {jobDetails["Company Name"]}
                    </p>
                    <p class = "hidden md:grid text-left section-heading text-primary-purple pt-10">
                        {jobDetails["Job Role"]}
                    </p>
                    {TextDesc("About the Role", jobDetails["About"])}
                    {TextDesc("Responsibilities", jobDetails["Responsibilities"])}
                    {TextDesc("Requirements", jobDetails["Requirements"])}
                </div>
                <div class = "md:block hidden col-span-12 md:col-span-4">
                    {ApplySticky(jobDetails)}
                </div>
            </div>
        </div>:
        <div class = "col-span-12 h-screen z-0">
            <div class="text-center pt-5 h-5/6 grid place-items-center w-full">
                <div role="status">
                    <span class = "pt-5 sub-heading text-sub-heading-mobile md:text-sub-heading pr-5">Getting your Job!</span>
                    <svg class="inline mr-2 w-8 h-8 text-white animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                    </svg>
                    <span class="sub-heading text-sub-heading-mobile md:text-sub-heding sr-only">Loading...</span>
                </div>
            </div>
        </div>}
    </div>
    );
  };

export default JobDetails;